// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-dmp {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    z-index: 2; 
}

.date-picker-container {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    /* background: rgba(255, 255, 255, 0.9); */
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background: #216ba5;
}

.picker-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding-top: 10px;
}

.today-button, .clear-button {
    padding: 5px 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.today-button {
    background-color: #4CAF50;
}

.clear-button {
    background-color: #f44336;
}

@media (max-width: 768px) {
    .header {
        flex-direction: column;
    }

    .navigation-buttons {
        margin-top: 10px;
    }
}

.CalButtons {
    width: 100%;
    padding: 15px;
    background: #0c3274;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    transition: background-color 0.3s ease;
    height: 50px;
  }
  
  .CalButtons:hover {
    background-color: #272726;
  }
  
  .CalButtons:focus {
    outline: none;
    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);
  }`, "",{"version":3,"sources":["webpack://./src/pages/calendar/DateMonthYearPicker.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yCAAyC;EAC3C","sourcesContent":[".header-dmp {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 20px;\n    z-index: 2; \n}\n\n.date-picker-container {\n    position: absolute;\n    top: 50px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1000;\n    /* background: rgba(255, 255, 255, 0.9); */\n    border-radius: 8px;\n    padding: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background: #216ba5;\n}\n\n.picker-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    padding-top: 10px;\n}\n\n.today-button, .clear-button {\n    padding: 5px 10px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    color: white;\n}\n\n.today-button {\n    background-color: #4CAF50;\n}\n\n.clear-button {\n    background-color: #f44336;\n}\n\n@media (max-width: 768px) {\n    .header {\n        flex-direction: column;\n    }\n\n    .navigation-buttons {\n        margin-top: 10px;\n    }\n}\n\n.CalButtons {\n    width: 100%;\n    padding: 15px;\n    background: #0c3274;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n    transition: background-color 0.3s ease;\n    height: 50px;\n  }\n  \n  .CalButtons:hover {\n    background-color: #272726;\n  }\n  \n  .CalButtons:focus {\n    outline: none;\n    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
